<template>
  <woot-modal :show.sync="show" :on-close="handleCloseWithGuard" modal-type="right-aligned">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('CREATE_CONTACT.TITLE')"
        :header-content="$t('CREATE_CONTACT.DESC')"
      />
      <contact-form
        ref="contactForm"
        :in-progress="uiFlags.isCreating"
        :on-submit="onSubmit"
        :default-values="defaultValues"
        @success="onSuccess"
        @cancel="onCancel"
        @force-cancel="onCancel"
      />
    </div>

    <!-- Modal de confirmação para dados não salvos -->
    <woot-delete-modal
      :show.sync="showUnsavedChangesConfirm"
      :on-close="cancelUnsavedClose"
      :on-confirm="confirmUnsavedClose"
      :title="$t('CONFIRM_UNSAVED_CHANGES.TITLE')"
      :message="$t('CONFIRM_UNSAVED_CHANGES.MESSAGE')"
      :confirm-text="$t('CONFIRM_UNSAVED_CHANGES.CONFIRM')"
      :reject-text="$t('CONFIRM_UNSAVED_CHANGES.CANCEL')"
    />
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import unsavedChangesGuard from 'shared/mixins/unsavedChangesGuard';
import ContactForm from './ContactForm';

export default {
  mixins: [unsavedChangesGuard],
  components: {
    ContactForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
    onWallet: {
      type: Object,
      default: () => ({}),
    },
    defaultValues: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
  },

  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.captureInitialFormState();
        }
      }
    }
  },

  data() {
    return {
      createdContact: null,
      showUnsavedChangesConfirm: false,
    };
  },

  methods: {
    onCancel() {
      this.$emit('cancel');
    },

    /**
     * Retorna o estado atual do formulário de contato.
     */
    getFormState() {
      const state = this.$refs.contactForm ? this.$refs.contactForm.getFormState() : {};
      console.log('[CreateContact] getFormState() retornando:', state);
      return state;
    },

    /**
     * Intercepta o fechamento do modal para verificar alterações não salvas.
     */
    handleCloseWithGuard() {
      console.log('[CreateContact] handleCloseWithGuard() chamado');
      console.log('[CreateContact] initialFormState:', this.initialFormState);
      console.log('[CreateContact] FormState atual:', this.getFormState());
      this.handleUnsavedClose(
        this.getFormState(),
        () => this.onCancel(),
        () => { this.showUnsavedChangesConfirm = true; }
      );
    },

    confirmUnsavedClose() {
      this.showUnsavedChangesConfirm = false;
      this.onCancel();
    },

    cancelUnsavedClose() {
      this.showUnsavedChangesConfirm = false;
    },

    /**
     * Captura estado inicial quando o modal é aberto.
     * Aguarda o ContactForm estar pronto.
     */
    captureInitialFormState() {
      console.log('[CreateContact] captureInitialFormState() chamado');
      setTimeout(() => {
        if (this.$refs.contactForm) {
          console.log('[CreateContact] $refs.contactForm existe, capturando estado...');
          const state = this.getFormState();
          this.captureInitialState(state);
          console.log('[CreateContact] Estado capturado:', state);
          console.log('[CreateContact] initialFormState:', this.initialFormState);
        } else {
          console.log('[CreateContact] $refs.contactForm NÃO existe ainda!');
        }
      }, 150);
    },

    onSuccess(contact) {
      this.$emit('success', contact || this.createdContact);
      this.$emit('cancel');
    },
    async onSubmit(contactItem) {
      if (this.onWallet) contactItem.wallet_id = this.onWallet.id;

      const response = await this.$store.dispatch(
        'contacts/create',
        contactItem
      );
      this.createdContact = response || null;
      return response;
    },
  },
};
</script>
